import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import Decimal from 'decimal.js-light'

import './index.css'
import './theme.scss'

Decimal.set({ toExpPos: 999, toExpNeg: -999 })

console.log(`run version: ${__VERSION__}`)

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)
